import countries from 'i18n-iso-countries'
countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
import config from '../../../config/index'
export default {
  methods: {
    localizeCountry(alpha3) {
      return countries.getName(alpha3, config.language);
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Localization/Countries/index.js